import * as React from 'react';

import * as styles from './CellLinksLayout.css';

interface ICellLinksLayoutProps {
  children: React.ReactNode;
}

export const CellLinksLayout: React.FC<ICellLinksLayoutProps> = ({ children }) => {
  return <ul className={styles['container']}>{children}</ul>;
};
